module.exports = __webpack_public_path__ + "img/id.ab265da8.svg";